@if (recurrence && recurrence.eventSeries.eventType) {
    <div class="card d-inline-block mb-0">
        <div class="card-body">
            <div>
                @if (recurrence.eventSeries.eventSeriesType !== EventSeriesType.Once) {
                    {{ recurrence.eventSeries.eventType.name }} to be done every
                    @for (field of recurrence.config.fields; track field; let fieldIndex = $index; let first = $first) {
                        @if (field.prefix) {
                            {{ field.prefix }}
                        }
                        @if (first) {
                            <br />
                        }
                        <div class="d-inline-flex flex-column align-items-center mx-2"
                             [adaptTooltip]="fieldDisabledStates[fieldIndex]?.disabledTooltip"
                             [ngClass]="{ 'mt-2 ms-0': first }">
                            <dx-select-box [items]="fieldChoices[fieldIndex]"
                                           [width]="field.width ?? 150"
                                           [disabled]="disabled || fieldDisabledStates[fieldIndex]?.disabled"
                                           class="d-inline-block"
                                           displayExpr="text"
                                           valueExpr="value"
                                           [value]="recurrence.eventSeries[field.eventSeriesField]"
                                           (valueChange)="updateField(field, $event)"></dx-select-box>
                            <small>{{ field.label }}</small>
                        </div>
                        @if (field.suffix) {
                            {{ field.suffix }}
                        }
                    }
                } @else {
                    {{ recurrence.eventSeries.eventType.name }} to be done on
                    <div class="d-inline-flex flex-column align-items-center me-2">
                        <dx-date-box type="date"
                                     class="d-inline-block"
                                     [disabled]="disabled"
                                     [min]="today"
                                     [max]="cycleEndDate"
                                     [value]="recurrence.eventSeries.startDate"
                                     (valueChange)="setSeriesStartDate($any($event))"></dx-date-box>
                        <span>date</span>
                    </div>
                }
            </div>
            <div class="mt-3">
                Starting
                <div class="d-inline-flex flex-column align-items-center mx-2">
                    <dx-date-box type="time"
                                 class="d-inline-block"
                                 pickerType="native"
                                 [disabled]="disabled"
                                 [value]="recurrence.eventSeries.startDate"
                                 (valueChange)="setSeriesStartTime($any($event))"></dx-date-box>
                    <span>time</span>
                </div>
                At
                <div class="d-inline-flex flex-column align-items-center mx-2">
                    <adapt-select-meeting-location [location]="location"
                                                   [potentialLocations]="potentialLocations"
                                                   [required]="false"
                                                   [disabled]="disabled"
                                                   (locationChange)="onLocationChange($event)"></adapt-select-meeting-location>
                    <span>location</span>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col-auto text-start">Duration: {{ duration }}</div>
                @if (upcomingTimes; as times) {
                    <div [adaptTooltip]="times[1]"
                         class="col text-end">Scheduled dates: {{ times[0] }}</div>
                }
            </div>
        </div>
    </div>
}
